import React, { Component } from 'react';
import { intlShape, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import _ from 'lodash';
import SelectField, { mapOptionsToSelectField } from '../../../../shared-components/SelectField/SelectField';

const LOCALE_PREFIX = 'DE/components/PhoneGroup/PhoneType';

export class PhoneType extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        phoneTypeOptions: PropTypes.object.isRequired
    };

    render() {
        const { phoneTypeOptions, intl } = this.props;

        return (
            <Field
                id="phone-type"
                name="phoneType"
                component={SelectField}
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.phone-type`})}
                optionList={mapOptionsToSelectField(phoneTypeOptions)}
            />
        );
    }
}

export const mapStateToProps = state => ({
    // Grab the properties directly from the message object
    phoneTypeOptions: _.get(state, `serverData.messages.${LOCALE_PREFIX}.phoneType`)
});

export default connect(mapStateToProps)(injectIntl(PhoneType));
